// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Users_container__IbgDY {
  background-color: #f5fafa;
  width: 100%;
  height: calc(100vh - 100px);
  overflow-y: auto;
  border-radius: 0 0 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-bottom: 20px;
}

.Users_header__Qkv-M h2 {
  margin: 0;
}

.Users_header__Qkv-M {
  width: 95%;
  background-color: white;
  border-radius: 8px;
}

.Users_headerContent__\\+xnLO {
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Users_addUserBtn__wOONh,
.Users_addManagerBtn__WPEfE {
  background-color: #3082f6;
  border: none;
  padding: 0 16px;
  border-radius: 12px;
  height: 44px;
  color: white;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.Users_table__WtS6S {
  width: 95%;
  background-color: white;
  padding-bottom: 1rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Users_tableHeader__5XkYO {
  padding: 12px 20px;
  height: 20px;
  background-color: #3082f6;
  width: 90%;
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: space-between;
  color: white;
}

.Users_tableHeader__5XkYO > div:not(:first-child):not(:nth-last-child(-n + 3)) {
  width: 120px;
  display: inline-block;
  white-space: normal;
  word-wrap: break-word;
}

.Users_tableHeader__5XkYO > div:first-child {
  width: 50px;
}

.Users_tableHeader__5XkYO > div:nth-last-child(-n + 2) {
  width: 50px;
}

.Users_tableHeader__5XkYO > div:nth-last-child(3) {
  width: 70px;
}

.Users_notificationsDiv__JK7-P {
  width: 400px;
  border-radius: 8px;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Users_paginationControls__6wSRT {
  display: flex;
  gap: 1rem;
}

.Users_filters__CqWao {
  display: flex;
  width: 90%;
  padding: 12px 20px;
  gap: 8px;
  flex-wrap: wrap;
}

.Users_filter__7qWSI {
  display: flex;
  align-items: center;
  gap: 5px;
}

.Users_filter__7qWSI select {
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  color: #676c7e;
}

.Users_filter__7qWSI label {
  color: rgba(27, 31, 59, 0.65);
}

.Users_filters__CqWao p {
  margin: 0;
  display: flex;
  align-items: center;
}

.Users_resetBtn__OdZV2,
.Users_prevBtn__LwgRA,
.Users_nextBtn__xw129 {
  border: none;
  background-color: #3082f6;
  padding: 3px 10px;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  cursor: pointer;
}

.Users_resetBtn__OdZV2:disabled,
.Users_prevBtn__LwgRA:disabled,
.Users_nextBtn__xw129:disabled {
  cursor: not-allowed;
  background-color: #7ca1d3;
}

.Users_btns__o\\+HM8 {
  display: flex;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/users/Users.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".container {\n  background-color: #f5fafa;\n  width: 100%;\n  height: calc(100vh - 100px);\n  overflow-y: auto;\n  border-radius: 0 0 0 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding-bottom: 20px;\n}\n\n.header h2 {\n  margin: 0;\n}\n\n.header {\n  width: 95%;\n  background-color: white;\n  border-radius: 8px;\n}\n\n.headerContent {\n  padding: 8px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.addUserBtn,\n.addManagerBtn {\n  background-color: #3082f6;\n  border: none;\n  padding: 0 16px;\n  border-radius: 12px;\n  height: 44px;\n  color: white;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.table {\n  width: 95%;\n  background-color: white;\n  padding-bottom: 1rem;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tableHeader {\n  padding: 12px 20px;\n  height: 20px;\n  background-color: #3082f6;\n  width: 90%;\n  border-radius: 0 0 8px 8px;\n  display: flex;\n  justify-content: space-between;\n  color: white;\n}\n\n.tableHeader > div:not(:first-child):not(:nth-last-child(-n + 3)) {\n  width: 120px;\n  display: inline-block;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.tableHeader > div:first-child {\n  width: 50px;\n}\n\n.tableHeader > div:nth-last-child(-n + 2) {\n  width: 50px;\n}\n\n.tableHeader > div:nth-last-child(3) {\n  width: 70px;\n}\n\n.notificationsDiv {\n  width: 400px;\n  border-radius: 8px;\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.paginationControls {\n  display: flex;\n  gap: 1rem;\n}\n\n.filters {\n  display: flex;\n  width: 90%;\n  padding: 12px 20px;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.filter {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.filter select {\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #f0f0f0;\n  color: #676c7e;\n}\n\n.filter label {\n  color: rgba(27, 31, 59, 0.65);\n}\n\n.filters p {\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.resetBtn,\n.prevBtn,\n.nextBtn {\n  border: none;\n  background-color: #3082f6;\n  padding: 3px 10px;\n  border-radius: 8px;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.resetBtn:disabled,\n.prevBtn:disabled,\n.nextBtn:disabled {\n  cursor: not-allowed;\n  background-color: #7ca1d3;\n}\n\n.btns {\n  display: flex;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Users_container__IbgDY`,
	"header": `Users_header__Qkv-M`,
	"headerContent": `Users_headerContent__+xnLO`,
	"addUserBtn": `Users_addUserBtn__wOONh`,
	"addManagerBtn": `Users_addManagerBtn__WPEfE`,
	"table": `Users_table__WtS6S`,
	"tableHeader": `Users_tableHeader__5XkYO`,
	"notificationsDiv": `Users_notificationsDiv__JK7-P`,
	"paginationControls": `Users_paginationControls__6wSRT`,
	"filters": `Users_filters__CqWao`,
	"filter": `Users_filter__7qWSI`,
	"resetBtn": `Users_resetBtn__OdZV2`,
	"prevBtn": `Users_prevBtn__LwgRA`,
	"nextBtn": `Users_nextBtn__xw129`,
	"btns": `Users_btns__o+HM8`
};
export default ___CSS_LOADER_EXPORT___;
